/**
 * @generated SignedSource<<54ec60b9ca6e408758c211002064453a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsRemoveSchemaMutation$variables = {
  schemaId: number;
};
export type MutationsRemoveSchemaMutation$data = {
  readonly removeSchema: {
    readonly documents: ReadonlyArray<number>;
    readonly schemas: ReadonlyArray<number>;
  } | null;
};
export type MutationsRemoveSchemaMutation = {
  response: MutationsRemoveSchemaMutation$data;
  variables: MutationsRemoveSchemaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "schemaId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "schemaId",
        "variableName": "schemaId"
      }
    ],
    "concreteType": "BlockingEntries",
    "kind": "LinkedField",
    "name": "removeSchema",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schemas",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "documents",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsRemoveSchemaMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsRemoveSchemaMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b732cc86567dc1c6690f42a17120572",
    "id": null,
    "metadata": {},
    "name": "MutationsRemoveSchemaMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsRemoveSchemaMutation(\n  $schemaId: Int!\n) {\n  removeSchema(schemaId: $schemaId) {\n    schemas\n    documents\n  }\n}\n"
  }
};
})();

(node as any).hash = "724a3402763533480992280dfd86f88e";

export default node;
